import { render, staticRenderFns } from "./viewTrenches.vue?vue&type=template&id=24b3f9f6&"
import script from "./viewTrenches.vue?vue&type=script&lang=js&"
export * from "./viewTrenches.vue?vue&type=script&lang=js&"
import style0 from "./viewTrenches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports